import { tzAxios } from 'api/axios';
import { ConcertsResponse } from 'api/responseTypes';

type WorkshopsResponse = ConcertsResponse;

export const getUpcomingWorkshops = async () =>
  (await tzAxios.get<WorkshopsResponse>('/ticket-zone/home?type=WORKSHOP')).data;
